const ENVIRONMENTS = {
  DEV: "dev",
  QA: "qa",
  PROD: "prod",
  LOCAL: "local",
} as const;

type Environment = (typeof ENVIRONMENTS)[keyof typeof ENVIRONMENTS];

const ENVIRONMENT: Environment = ENVIRONMENTS.PROD as Environment;

const protocol = ENVIRONMENT === ENVIRONMENTS.LOCAL ? "http" : "https";

const baseUrls = {
  local: "localhost:8080",
  dev: "clubactivitytestapi.azurewebsites.net",
  qa: "api.auxwitqa.com",
  prod: "api.beefabric.in",
};

const blobUrls = {
  local: "https://sabeefabricdev.blob.core.windows.net",
  dev: "https://sabeefabricdev.blob.core.windows.net",
  qa: "https://sabeefabricqa.blob.core.windows.net",
  prod: "https://sabeefabricprod.blob.core.windows.net",
};

const env = {
  apiUrl: `${protocol}://${baseUrls[ENVIRONMENT]}/api/v1`,
  authUrl: `${protocol}://${baseUrls[ENVIRONMENT]}/auth`,
  blobUrl: blobUrls[ENVIRONMENT],
  locationNominationApi: "https://nominatim.openstreetmap.org/search",
  promptBeforeIdle: 0.5, //minutes
  renewalTimeBeforeExpiry: 2, //minutes
  googleClientId: "430557436180-oji5sulajik9bc3p6vc4tikf5iulojcc.apps.googleusercontent.com",
  facebookAppId: "1204412374632737",
  zoomSdkKey: "kW54sM3PRg27vuyESXkFRQ",
  modalUrl: "https://teachablemachine.withgoogle.com/models/jvYMpDMVs/",
  maxImageSize: 3 // MB
};

export default env;